import React from "react";
import { Box } from "@mui/material";
import styles from "./previewCerificateTemplate.module.scss";
import PropTypes from "prop-types";


const PreviewCertificateTemplate = (props) => {
  const { certificateTemplate } = props;
 
  return (
    <Box className={styles.folderWrapper} data-testid="PreviewCertificateTemplate">
      <iframe
        src={`${certificateTemplate}#toolbar=0&navpanes=0&scrollbar=0`}
        title="PDF Preview"
        width="800px"
        height="500px"
        style={{ border: "none" }}
      >
        This browser does not support PDFs.
      </iframe>
    </Box>
  );
};
export default PreviewCertificateTemplate;
PreviewCertificateTemplate.propTypes = {
  certificateTemplate:PropTypes.any
}